import React from 'react';
import loadable from '@loadable/component';
import { PublicationSkeleton } from './Publication.skeleton';

export default loadable(() => import(/* webpackChunkName: 'Publication' */ '.'), {
    fallback: React.createElement(PublicationSkeleton),
});
